import { projectManifest } from './project'

const DB_NAME = 'geoworkbench'
const DB_VERSION = 1
const PROJECT_STORE = 'projects'
const DATASET_STORE = 'datasets'
const LAST_PROJECT_KEY = 'geoworkbench:last-project-id'

function openDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)
    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains(PROJECT_STORE)) db.createObjectStore(PROJECT_STORE, { keyPath: 'id' })
      if (!db.objectStoreNames.contains(DATASET_STORE)) db.createObjectStore(DATASET_STORE, { keyPath: 'id' })
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

function transaction(storeNames, mode, handler) {
  return openDatabase().then(db => new Promise((resolve, reject) => {
    const tx = db.transaction(storeNames, mode)
    tx.addEventListener('complete', () => db.close())
    handler(tx, resolve, reject)
    tx.onerror = () => reject(tx.error)
  }))
}

export const projectRepository = {
  async save(project) {
    const manifest = projectManifest(project)
    manifest.updatedAt = new Date().toISOString()
    await transaction([PROJECT_STORE, DATASET_STORE], 'readwrite', (tx, resolve, reject) => {
      tx.objectStore(PROJECT_STORE).put(manifest)
      project.layers.filter(layer => layer.data).forEach(layer => {
        tx.objectStore(DATASET_STORE).put({ id: `${project.id}:${layer.id}`, projectId: project.id, layerId: layer.id, data: layer.data })
      })
      tx.oncomplete = () => resolve()
      tx.onerror = () => reject(tx.error)
    })
    localStorage.setItem(LAST_PROJECT_KEY, project.id)
    return manifest
  },

  async loadLast() {
    const projectId = localStorage.getItem(LAST_PROJECT_KEY)
    if (!projectId) return null
    return transaction([PROJECT_STORE, DATASET_STORE], 'readonly', (tx, resolve, reject) => {
      const projectRequest = tx.objectStore(PROJECT_STORE).get(projectId)
      projectRequest.onerror = () => reject(projectRequest.error)
      projectRequest.onsuccess = () => {
        const project = projectRequest.result
        if (!project) return resolve(null)
        const layers = project.layers || []
        const requests = layers.map(layer => {
          if (!['vector', 'raster'].includes(layer.type)) return Promise.resolve(layer)
          return new Promise((layerResolve, layerReject) => {
            const request = tx.objectStore(DATASET_STORE).get(`${project.id}:${layer.id}`)
            request.onsuccess = () => layerResolve({ ...layer, data: request.result && request.result.data })
            request.onerror = () => layerReject(request.error)
          })
        })
        Promise.all(requests).then(restoredLayers => resolve({ ...project, layers: restoredLayers })).catch(reject)
      }
    })
  }
}
